import { IApplicationState } from '../../types/redux';
import { IOfferForAnalytic } from '../../utils/tracking/types';

export const selectUnfinishedAnketaModalOffer = (state: IApplicationState): IOfferForAnalytic | null =>
  state.calculator.unfinishedAnketaModal.offerForAnalytic;
